<script>
import json from "../../db.json";
import Footer from "@/components/Footer";
export default {
  components: {
    Footer
  },
  data() {
    return {
      cards: json.cards,
    };
  },
  methods: {
    getCard(title) {
      let data = this.cards;
      return data.filter((item) => {
        return item.title == title;
      });
    },
  },
  // mounted() {
  //   document.querySelector("body").style.position = "fixed";
  // },
};
</script>

<template>
  <section>
    <div class="modal" v-for="prjkt in getCard($route.params.title)" :key="prjkt.id">
      <!-- <div class="modal__bg"></div> -->
      <a href="/" class="modal__close"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
          viewBox="0 0 24 24">
          <path d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z" />
        </svg>
      </a>
      <div class="modal__content" :class="prjkt.class">
        <!--Info-->
        <div class="project_hero">
          <div class="spotlight">
            <video class="bg-blur-video" :src="prjkt.img.replace('.png', '/snapshot.mp4')" autoplay muted loop></video>
            <video class="snapshot" :src="prjkt.img.replace('.png', '/snapshot.mp4')" autoplay muted loop></video>
          </div>
          <!---->
          <ul class="about">
            <li v-for="info in prjkt.infos" :key="info">
              {{ info }}
            </li>
            <!--Tools-->
            <li>
              <!-- <span>Tools:</span> -->
              <ul class="tools">
                <li v-for="tool in prjkt.tools" :key="tool.id">
                  <span>{{ tool.toolName }}</span>
                  <img :src="tool.toolIcon" alt="" />
                </li>
              </ul>
            </li>
            <!---->
            <li class="view" v-if="prjkt.link && prjkt.link.length > 0">
              <a :href="prjkt.link" target="_new"><span>View Live</span>
                <img src="/imgs/link.png" alt="link" width="20" /></a>
            </li>
          </ul>
        </div>
        <!--Screens-->
        <div class="screens">
          <div class="brief">
            <hr />
            <div class="brief__content">
              <div>
                <p v-for="brief in prjkt.brief" :key="brief">
                  {{ brief }}
                </p>
              </div>
              <div>
                <ul>
                  <li v-if="prjkt.client && prjkt.client.length > 0">Client
                    <span>{{ prjkt.client }}</span>
                  </li>
                  <li v-if="prjkt.company && prjkt.company.length > 0">Company
                    <span>{{ prjkt.company }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="shots">
            <img v-for="gall in prjkt.gallery" :key="gall" :src="gall" alt="" loading="lazy" />
          </div>
        </div>
      </div>
    </div>
    <!-- <Footer /> -->
  </section>
</template>

<style lang="scss" scoped>
@import "../assets/css/mixins";

.modal {
  font-family: 'Panchang';
  position: relative;
  background: #EFEFFF;

  // &__bg {
  //   background: linear-gradient(45deg, black, transparent);
  // }
  &__content {
    position: relative;
    // height: 100vh;
    padding: 0em 0em;
    color: $blue;
    justify-content: space-between;
    display: flex;
    flex-flow: column;
    gap: 0em;
    overflow: auto;

    @include media(sm) {
      flex-flow: column;
      padding: 0 2em;
    }

    .about {
      display: flex;
      gap: 15px;
      list-style: none;
      padding: 1.2em 0em;
      flex: 1;
      align-items: center;
      flex-direction: column;
      // height: 100%;
      justify-content: center;
      background: #EFEFFF;
      position: relative;
      margin: 0;

      @include media(sm) {
        position: relative;
        top: 0;
      }

      .tools {
        gap: 2em;

        li {
          display: flex;
          flex-flow: row;
          align-items: center;
          gap: 0.3em;
          font-size: 14px;
          font-weight: bold;
        }
      }

      > :not(.tools li) li {
        line-height: unset !important;
        background: none;
        padding: 5px 0;

        &:first-child {
          font-size: 3vw;
          padding: 0em 1.25em 100px;
          inline-size: unset;
          font-weight: bolder;
          text-align: center;
          flex: fit-content;
          align-content: space-evenly;

          @include media(xs) {
            font-size: 3em;
          }
        }
      }

      .view {
        a {
          font-size: 2em;
          align-items: flex-end;
          line-height: 1;

          @include media(xs) {
            font-size: 1.5em;
          }

          img {
            width: 25px;
          }
        }
      }
    }
  }

  .mobile {
    // display: flex;
    // flex-flow: column;
    // gap: 2em;

    .shots {
      img {
        width: 100% !important;
        // @include media(sm) {
        //   width: calc(50% - 1em) !important;
        // }
      }
    }

    .about {
      position: unset;
      align-self: auto;
    }
  }
}

.project_hero {
  display: flex;
  flex-direction: row;
  height: 100vh;
  width: 100%;
  padding: 0;
  flex: none;
  align-content: center;
  flex-wrap: wrap;
  overflow: hidden !important;
}

.spotlight {
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  // background: url("/imgs/projects/bigsis/home.png") top center;
  position: relative;
  height: inherit;

  video.snapshot {
    position: relative;
    z-index: 1;
    width: 90%;
    height: auto;
    object-fit: scale-down;
    mix-blend-mode: unset;
  }

  video.bg-blur-video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    /* Stretches to fill the container */
    z-index: 0;
    /* Sits at the absolute bottom */
  }

  &::after {
    content: "";
    position: absolute;
    z-index: 0;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: repeating-linear-gradient(90deg,
        rgba(255, 255, 255, 0.15) 0px,
        rgba(255, 255, 255, 0.05) 15px,
        rgba(0, 0, 0, 0.4) 28px,
        rgba(0, 0, 0, 0.5) 30px,
        rgba(255, 255, 255, 0.15) 32px);

    backdrop-filter: blur(34px);
  }

  &::before {
    // content: "";
    position: absolute;
    top: -100%;
    left: -100%;
    width: 300%;
    height: 300%;
    background: url("/imgs/noisy.png");
    opacity: .6;
    z-index: 1;
    pointer-events: none;
    animation: grain 8s steps(10) infinite;
  }
}

.brief {
  padding: 8em;

  hr {
    border-style: solid;
    color: $blue;
    margin: 0em 0em 4em 0em;
    padding: 0;
  }

  &__content {
    display: flex;
    flex-direction: row-reverse;

    ul {
      margin: 0;
      padding: 0;
      display: flex;
      flex-direction: column;
      max-width: 50%;
      gap: .4em;

      li {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        justify-content: space-between;

        span {
          font-weight: bold;
        }
      }
    }

    div {
      flex: 1;

      p {
        position: relative;
        padding-left: 1em;
        font-size: 1.375rem;
        font-weight: bold;
        margin: 0;

        // display: list-item;
        // list-style: square;
        &::before {
          content: "";
          position: absolute;
          width: 8px;
          height: 8px;
          background: $blue;
          left: 0;
          top: 8px;
        }
      }
    }
  }


}

.screens {
  max-width: 100%;
  flex: 3;

  @include media(sm) {
    max-width: 100%;
  }
}
</style>
